
// open popup slider
var index;
class imageZoomJS {
  constructor() {
      this.overlay = null;
      this.modal = document.querySelector('#zoom-productmedia');
      this.enableZoomOnHover();        
  }

  enableZoomOnHover=()=>{
      const images = document.querySelectorAll('.product-images-wrapper .image-magnify-hover');
      images.forEach(image => {
          image.onclick = (event) => {
            event.preventDefault();

              this.clicked_image = event.currentTarget;
              index = parseInt(this.clicked_image.getAttribute('data-index'));
              if(window.zoomMediaLoaded == true){
                  this.openZoomModal();
              }else{
                  this.buildProductMediaUI();
              }             
          };
      });
  }

  buildProductMediaUI=()=>{
      let productMedia = window.globalVariables.product.media;
      if(!productMedia) return;

      let finalHTML = '';
      productMedia.forEach((media) => {
          let mediaHTML = ``;
          if(media.media_type == 'image'){
              mediaHTML = `<div class="swiper-slide justify-content-center w-100 modelMedia modelMedia-${media.id}" data-mediaID="${media.id}">
              <div class="position-relative" style="background-image: var(--bg-image); max-width: 698px;">
                <img src="${media.src}" alt="{{ product.title }}" title="{{ product.title }}" width="${media.width}" height="${media.height}" class="w-100 h-100 mx-auto object-fit-contain"/>
              </div>
            </div>`;
          }else if(media.media_type == 'video'){
              let video_obj = media.sources.filter((item)=>{ return item.format == 'mp4' && (item.height == '1080' || item.height == '720'); });
              if(video_obj.length == 0){
                  video_obj = media.sources.filter((item)=>{ return item.format == 'mp4' });
              }
              mediaHTML = `<div class="swiper-slide w-100 position-relative modelMedia-${media.id}" data-mediaID="${media.id}">
              <div class="overflow-hidden">
                <div class="banner-img-wrap position-relative h-100">
                  <div class="custom-video-container w-100">                       
                      <video class="w-100" autoplay playsinline muted loop controls poster="${media.preview_image.src}" src="${video_obj[0].url}"></video>
                  </div>
                </div>
              </div>
            </div>`;
          }else if(media.media_type == 'external_video'){
              mediaHTML = `<div class="swiper-slide w-100 position-relative modelMedia-${media.id}" data-mediaID="${media.id}">
                  <div class="overflow-hidden">
                    <div class="banner-img-wrap position-relative h-100">
                      <div class="custom-video-container w-100">
                        <iframe class="w-100 h-100" src="https://www.youtube.com/embed/${media.external_id}?start=0&autoplay=1&loop=1&mute=0&controls=1" allowfullscreen="" width="400" height="400" allow="autoplay" title="yt-video"></iframe>
                      </div>
                    </div>
                  </div>
                </div>`;
          }
          finalHTML += mediaHTML;
      });

      let sliderHTML = `<slider-element class="swiper-container carousel position-relative">
        <div class="swiper swiper-slider card-carousel" data-slider='{
          "loop": false,
          "slidesPerView": "1",
          "grabCursor": true,
          "navigation": {
            "nextEl": ".swiper-button-next",
            "prevEl": ".swiper-button-prev"
          }
        }'>
      <div class="swiper-wrapper">${finalHTML}</div>
    </div>
    <div class="mobile-arrow">
      <div class="swiper-button-next icon-arrow-right icon-next"></div>
      <div class="swiper-button-prev icon-arrow-left icon-previous"></div>
    </div>
  </slider-element>`;
      
      this.modal.querySelector('[data-zoomMediaContainer]').innerHTML = sliderHTML;
      this.openZoomModal();
      window.zoomMediaLoaded = true;
  }

  openZoomModal=()=>{
      // let modalMedia = document.querySelector(`[data-zoommediacontainer] li:nth-child(${this.clicked_image.dataset.index})`);
      
      // this.modal.show();
      document.querySelector("#zoom-productmedia .modal").classList.add("open");
     // this.slideTo(3)
      this.modal.querySelector('slider-element').slideTo(index-1);
      document.body.classList.add('scroll-fixed');
      
      siteOverlay.prototype.showOverlay();
       //modalMedia.scrollIntoView();
  }
}

typeof imageZoomJS !== 'undefined' && new imageZoomJS();